import { customList } from "country-codes-list";

// Get country code mapping using country-codes-list package
const countryCodeMap = customList('countryNameEn', '{countryCode}');
const countryNameMap = customList('countryCode', '{countryNameEn}');

/**
 * Get ISO 2-letter country code from country name
 * @param countryName - Full country name (e.g., "Finland", "Sweden")
 * @returns ISO 2-letter country code (e.g., "FI", "SE") or "XX" if not found
 */
export function getCountryCode(countryName: string): string {
  // If already a valid 2-letter ISO code, return it directly
  if (countryName.length === 2 && countryNameMap[countryName.toUpperCase()]) {
    return countryName.toUpperCase();
  }
  return countryCodeMap[countryName] || "XX";
}

/**
 * Get country name from an ISO 2-letter code or a full country name.
 * Handles mixed DB state where some rows store "FR" and others store "France".
 * @param input - ISO 2-letter code (e.g., "NO") or full name (e.g., "Norway")
 * @returns Full country name (e.g., "Norway") or "Unknown" if not found
 */
export function getCountryName(input: string): string {
  if (!input) return "Unknown"
  // Try as ISO code first (e.g. "NO" → "Norway")
  const byCode = countryNameMap[input.toUpperCase()]
  if (byCode) return byCode
  // Try as full name — if it's a recognised name, return it directly
  if (countryCodeMap[input]) return input
  return "Unknown"
}

/**
 * Get all countries as an array of {code, name} objects sorted by name
 * @returns Array of countries with code and name
 */
export function getAllCountries(): Array<{ code: string; name: string }> {
  return Object.entries(countryNameMap)
    .map(([code, name]) => ({ code, name }))
    .sort((a, b) => a.name.localeCompare(b.name));
} 
